module.exports = __webpack_public_path__ + "static/media/art62.9d26b4ae.jpg";